import React from 'react';

import { Item, ItemProps } from './Item';
import styles from './person.scss';

interface Props extends Omit<ItemProps, 'children'> {
  id: string | number;
  name?: string | null;
  role?: string | null;
  photoPath?: string | null;
}

export const PersonItem: React.FC<Props> = ({ id, name, role, photoPath, onClick, ...rest }) => {
  const initial = name && name.length ? name[0] : '';
  const image = photoPath ? (
    <img data-testid="image" className={styles.image} src={photoPath} alt={name || ''} />
  ) : (
    initial
  );

  return (
    <Item key={id} hoverText="Edit Member" hoverIcon="edit" onClick={onClick} {...rest}>
      <div className={styles.imageBox}>{image}</div>
      <div className={styles.info}>
        <span className={styles.name}>{name}</span>
        <span className={styles.role}>{role}</span>
      </div>
    </Item>
  );
};
